var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "outer supply-chain" },
    [
      _c(
        "search-panel",
        {
          attrs: { "show-btn": "", flex: "" },
          on: {
            getList: function ($event) {
              return _setup.getList(1)
            },
          },
        },
        [
          _c(
            "div",
            [
              _c("p", [_vm._v("商品类目")]),
              _c(_setup.ChangeCat, {
                attrs: { "parent-id": 1 },
                on: { change: _setup.handleChange },
              }),
            ],
            1
          ),
          _c(
            "div",
            [
              _c("p", [_vm._v("商品ID")]),
              _c("el-input-number", {
                attrs: {
                  size: "mini",
                  controls: false,
                  min: 0,
                  precision: 0,
                  placeholder: "请输入内容",
                  clearable: "",
                },
                model: {
                  value: _setup.params.relationGoodsIds,
                  callback: function ($$v) {
                    _vm.$set(_setup.params, "relationGoodsIds", $$v)
                  },
                  expression: "params.relationGoodsIds",
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            [
              _c("p", [_vm._v("商品名称")]),
              _c("el-input", {
                attrs: {
                  clearable: "",
                  placeholder: "请输入内容",
                  size: "mini",
                },
                on: {
                  clear: function ($event) {
                    return _setup.getList(1)
                  },
                },
                model: {
                  value: _setup.params.relationGoodsName,
                  callback: function ($$v) {
                    _vm.$set(_setup.params, "relationGoodsName", $$v)
                  },
                  expression: "params.relationGoodsName",
                },
              }),
            ],
            1
          ),
          _c(
            "el-button",
            {
              attrs: { slot: "button-right", size: "mini" },
              on: {
                click: function ($event) {
                  return _setup.operation("reset")
                },
              },
              slot: "button-right",
            },
            [_vm._v(" 重 置 ")]
          ),
          _c(
            "el-button",
            {
              attrs: { slot: "button-right", type: "primary", size: "mini" },
              on: { click: _setup.onShowAddDialog },
              slot: "button-right",
            },
            [_vm._v(" 添加供货商品 ")]
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _setup.loading,
              expression: "loading",
            },
          ],
          ref: "multipleTable",
          staticClass: "tableBox",
          staticStyle: { width: "100%" },
          attrs: {
            data: _setup.tableData,
            "element-loading-text": "拼命加载中",
            "row-key": "relationGoodsId",
            "header-cell-style": {
              background: "#f5f7fa",
            },
            size: "medium",
          },
        },
        [
          _c("el-table-column", {
            attrs: { type: "expand" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c(
                      "el-table",
                      {
                        staticStyle: { "margin-left": "148px" },
                        attrs: {
                          data: row.tradeGoodsSkuVoList,
                          size: "medium",
                        },
                      },
                      [
                        _c("el-table-column", {
                          attrs: { label: "商品规格" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "wd-flex wd-flex-align-center",
                                      },
                                      [
                                        _c("el-image", {
                                          staticStyle: {
                                            width: "50px",
                                            height: "50px",
                                          },
                                          attrs: {
                                            src: scope.row.imageIds,
                                            "preview-src-list": [
                                              scope.row.imageIds,
                                            ],
                                            fit: "cover",
                                          },
                                        }),
                                        _c(
                                          "div",
                                          { staticClass: "margin-l5" },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(scope.row.specValue) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        }),
                        _c("el-table-column", {
                          attrs: { label: "店铺销售价" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm._v(
                                      " " + _vm._s(+scope.row.sellPrice) + " "
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        }),
                        _c("el-table-column", {
                          attrs: { label: "供货价" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm._v(
                                      " " + _vm._s(+scope.row.supplyPrice) + " "
                                    ),
                                    scope.row.supplyType
                                      ? _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              scope.row.supplyType == 1
                                                ? `（直接设置）`
                                                : `（以佣金比例${Number(
                                                    (
                                                      scope.row.supplyPercent *
                                                      100
                                                    ).toFixed(0)
                                                  )}%设置）`
                                            )
                                          ),
                                        ])
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        }),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { prop: "relationGoodsId", label: "商品ID", width: "100" },
          }),
          _c("el-table-column", {
            attrs: { prop: "relationGoodsName", label: "商品名称" },
          }),
          _c("el-table-column", {
            attrs: { prop: "backendCategoryPath", label: "商品类目" },
          }),
          _c("el-table-column", {
            attrs: { label: "操作", width: "150" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c(
                      "el-link",
                      {
                        attrs: { type: "danger" },
                        on: {
                          click: function ($event) {
                            return _setup.operation("delete", row)
                          },
                        },
                      },
                      [_vm._v(" 移除选品中心 ")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _setup.tableData && _setup.tableData.length > 0
        ? _c("el-pagination", {
            attrs: {
              "current-page": _setup.params.currentPage,
              "page-sizes": [10, 20, 30, 50],
              "page-size": _setup.params.nowPageSize,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _setup.params.count,
            },
            on: {
              "size-change": _setup.handleSizeChange,
              "current-change": _setup.handleCurrentChange,
            },
          })
        : _vm._e(),
      _c(_setup.AddGoodsDialog, {
        attrs: { show: _setup.showAddDialog },
        on: {
          clear: function ($event) {
            _setup.showAddDialog = false
          },
          success: function ($event) {
            return _setup.getList(1)
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }